export interface PaymentTermConstructor {
  id: number
  name: string
  description: string
  active: boolean
}

export class PaymentTerm {
  readonly id: number
  readonly name: string
  readonly description: string
  readonly active: boolean

  constructor(data: PaymentTermConstructor) {
    this.id = data.id
    this.name = data.name
    this.description = data.description
    this.active = data.active
  }
}
